﻿window.cTraitementDispoSession = function (bddRef, data, icone, funcContentEncours, funContentFini, funcContentError, funcAlways) {
    var Me = this;
    var BtTrait = null
    if (typeof page.dxCtrlBarreTache != 'undefined') { BtTrait = page.dxCtrlBarreTache.mGetTraitement(icone); }
    else { BtTrait = page.mGetTraitement(icone); }
    BtTrait.on("click", function () { Me.showTooltip(); })
    BtTrait.jauge.element().on("click", function () { Me.showTooltip(); })
    BtTrait.$DivJauge.on("click", function () { Me.showTooltip(); })

    var idx = Math.floor(Math.random() * 100000);
    data.idx = idx
    var fini = "0";
    var error = "0";
    var timeOutCall = null;
    var dataResult = null;
    var func = function () {
        bddRef.mAjaxCall(data, function (data) {
            dataResult = data;
            fini = data.fini;
            error = data.error;
            if (fini == "1") {
                BtTrait.jauge.mHide();
                if (error == "1") {
                    BtTrait.find(".fa-times-circle").show(100);
                }
                //if (tt) {
                //    fini == "0"
                //    tt.hide(); tt = null

                //    window.setTimeout(function () { fini == "1"; Me.showTooltip() }, 1000);
                //} else { Me.showTooltip() }
                Me.showTooltip()
            }
            else {
                if (progressBar) {
                    BtTrait.jauge.mHide();
                    if (parseInt(dataResult.valueprogress) / parseInt(dataResult.totalprogress) * 100 > 100) debugger;
                    progressBar.option("value", parseInt(dataResult.valueprogress));
                    progressBar.option("max", parseInt(dataResult.totalprogress));
                }
                if (typeof dataResult.valueprogress != 'undefined') BtTrait.$DivJauge.css("width", parseInt(dataResult.valueprogress) / parseInt(dataResult.totalprogress) * 100 + "%")
                timeOutCall = window.setTimeout(function () { func() });
            }
        }, function () {
            if (funcAlways) funcAlways();
        }, function () {
            BtTrait.find(".fa-times-circle").show(100);
            error = "1"
            BtTrait.jauge.mHide();
            Me.showTooltip();
        });
    }
    func();

    this.funcClick = function () {
        if (fini == "1") { return funClickFini }
        else { return funcClickEncours }
    }

    var tt = null;
    var progressBar = null;
    this.showTooltip = function () {
        if (tt) tt.hide();
        progressBar = null;
        tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            target: BtTrait,
            width: 400,
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "20px")
                contentElement.css("font-size", "16px")
                contentElement.css("white-space", "normal")
                if (error == "1") {
                    funcContentError(contentElement)
                }
                else {
                    if (fini == "1") {
                        funContentFini(dataResult, contentElement, function () { tt.hide(); BtTrait.remove(); })
                    }
                    else {
                        progressBar = funcContentEncours(contentElement)
                        if (progressBar) {
                            progressBar.option("value", ((dataResult) ? parseInt(dataResult.valueprogress) : 0));
                            progressBar.option("max", ((dataResult) ? parseInt(dataResult.totalprogress) : 100));
                            //if (dataResult) BtTrait.$DivJauge.css("width",parseInt(dataResult.valueprogress)/ parseInt(dataResult.totalprogress)  * 100 + "%")
                        }
                    }
                }
                $("<div style='padding-bottom:20px'/>").appendTo(contentElement);
                $("<div/>").appendTo($("<div style='width:100%;text-align:right;'/>").appendTo(contentElement)).dxCtrlButton({
                    text: 'Annuler',
                    onClick: function (e) {
                        if (timeOutCall) window.clearTimeout(timeOutCall);
                        tt.hide();
                        BtTrait.remove();
                        if (fini == "0" && error == "0") {
                            data.stop = "1"
                            bddRef.mAjaxCall(data, function (data) { });
                        }
                    }
                })
            },
            //onHidden: function (e) { if (e.component.fini == "1") BtTrait.remove(); }
        }).dxCtrlTooltip("instance")
        tt.component().fini = fini
        tt.show();
    }

    this.showTooltip();
}

window.mZip = function (bddRef, lstUrlString) {
    var lstUrl = [];
    lstUrlString.forEach(function (url) { lstUrl.push({ url: url }) });
    var traitement = new cTraitementDispoSession(bddRef, { command: "compressfile", lsturl: lstUrl }, "fas fa-cloud-upload-alt",
        function (contentElement) {
            $("<div>Votre archive est en cours de génération.<br/>Vous serez prévenu ici quand celle-ci sera prête à être téléchargée.</div>").appendTo(contentElement)
            var progressBarStatus = $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxProgressBar({
                min: 0,
                max: 100,
                width: "100%"
            }).dxProgressBar("instance");
            return progressBarStatus;
        },
        function (dataResult, contentElement, funcClose) {
            $("<div style='padding-bottom:15px;'>Votre archive est prête.</div>").appendTo(contentElement)
            $("<div/>").appendTo($("<div style='width:100%;text-align:right;'/>").appendTo(contentElement)).dxCtrlButton({
                text: 'Télécharger l\'archive',
                onClick: function (e) {
                    mDownLoadFile(option.bddCtrl, [dataResult.urlzip]);
                    if (funcClose) funcClose()
                }
            })
        },
        function (contentElement) {
            $("<div>Impossible de créer l'archive.</div>").appendTo(contentElement)
        });
}